module.exports = __webpack_public_path__ + "img/testing.69b87034.png";